import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutGrid, Menu, X, Users, Calendar, Building2, Fingerprint, Settings, Wallet, Car } from 'lucide-react';
import { Logo } from '../ui';
import { useUIStore } from '../../../stores/uiStore';

export function MobileBottomNav() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);
  const { pathname } = useLocation();
  const { openModal } = useUIStore();
  const openPremium = () => { setOpen(false); openModal('premium'); };

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      {/* Bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-[60] bg-primary-600 text-white border-t border-primary-700/20 shadow-[0_-2px_8px_rgba(0,0,0,0.08)]">
        <div className="grid grid-cols-2 py-2">
          <button onClick={() => setOpen(true)} className="flex flex-col items-center justify-center text-white/90 hover:text-white">
            <Menu className="h-6 w-6" />
            <span className="text-xs mt-1">Menu</span>
          </button>
          <Link to="/dashboard" className={`flex flex-col items-center justify-center ${pathname === '/dashboard' ? 'text-white' : 'text-white/90 hover:text-white'}`}>
            <LayoutGrid className="h-6 w-6" />
            <span className="text-xs mt-1">Dashboard</span>
          </Link>
        </div>
      </div>

      {/* Bottom sheet (animated) */}
      <div className="md:hidden">
        {/* Backdrop fade */}
        <div
          className={`fixed inset-0 z-[70] bg-black/40 transition-opacity duration-300 ${open ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
          onClick={() => setOpen(false)}
        />
        {/* Side panel slide-in */}
        <div
          ref={panelRef}
          className={`fixed inset-y-0 left-0 z-[80] w-72 sm:w-80 bg-primary-600 text-white shadow-2xl ring-1 ring-primary-700/30 transform transition-transform duration-300 ${open ? 'translate-x-0' : '-translate-x-full'}`}
        >
            {/* Header */}
            <div className="flex items-center justify-between px-4 py-3 border-b border-primary-400/30">
              <div className="flex items-center gap-2">
                <Logo className="h-8 w-auto" variant="white" />
              </div>
              <button onClick={() => setOpen(false)} className="p-2 text-white/80 hover:text-white"><X className="h-5 w-5" /></button>
            </div>

            {/* Links */}
            <nav className="px-2 py-3">
              <ul className="space-y-1">
                {[
                  { name: 'Employees', href: '/employees', Icon: Users },
                  { name: 'Attendance', href: '/attendance', Icon: Calendar },
                  { name: 'Sites', href: '/sites', Icon: Building2 },
                  { name: 'Devices', href: '/devices', Icon: Fingerprint },
                  { name: 'System', href: '/system', Icon: Settings },
                ].map(({ name, href, Icon }) => {
                  const active = pathname === href;
                  return (
                    <li key={href}>
                      <Link
                        to={href}
                        className={`group flex items-center justify-between px-3 py-2.5 rounded-lg transition-colors ${active ? 'bg-white/10 text-white' : 'text-white/90 hover:bg-white/10 hover:text-white'}`}
                        onClick={() => setOpen(false)}
                      >
                        <span className="flex items-center gap-3">
                          <Icon className="h-5 w-5" />
                          <span className="text-sm font-medium">{name}</span>
                        </span>
                      </Link>
                    </li>
                  );
                })}
                <li><div className="h-px bg-white/20 my-2" /></li>
                {/* Premium quick actions */}
                {[{ name: 'Payroll', Icon: Wallet }, { name: 'HR', Icon: Users }, { name: 'Parking', Icon: Car }].map(({ name, Icon }) => (
                  <li key={name}>
                    <button
                      type="button"
                      onClick={openPremium}
                      className="group w-full flex items-center justify-between px-3 py-2.5 rounded-lg text-left text-white/90 hover:bg-white/10 hover:text-white"
                    >
                      <span className="flex items-center gap-3">
                        <Icon className="h-5 w-5" />
                        <span className="text-sm font-medium">{name}</span>
                      </span>
                    </button>
                  </li>
                ))}
              </ul>
            </nav>

            {/* Footer */}
            <div className="absolute bottom-0 left-0 right-0 px-4 py-3 border-t border-primary-400/30 text-xs text-white/80 flex justify-center">
              CSAS@2025
            </div>
          </div>
        </div>
    </>
  );
}


